import React from 'react';

import { useBuildings } from 'store/apis';
import { BasicSelector, BasicSelectorProps } from './basic-selector';

type BuildingSelectorProps = BasicSelectorProps & {
  value: number | null;
  onChange?: (value: number | null) => void;
};

export const BuildingSelector = ({ onChange: _onChange = () => {}, value, ...rest }: BuildingSelectorProps) => {
  const { data: buildings, isLoading } = useBuildings();
  const label = 'Building';
  const placeholder = 'Select a Building...';

  const options = buildings.map(({ id }) => id);
  const getOptionLabel = (option: number) => buildings.find(({ id }) => id === option)?.location || '';
  const onChange: any = (_: any, value: number) => _onChange(value);

  const componentProps: Partial<BuildingSelectorProps> = {
    label,
    placeholder,
    value,
    options,
    getOptionLabel,
    onChange,
    optionsConfig: false,
    loading: isLoading,
    optionsLoadingText: 'Loading buildings...',
    noOptionsText: 'No building',
  };

  return <BasicSelector {...componentProps} {...rest} />;
};
